import React from 'react'
import { PricingPlan } from '../types'
import { PricingPlanElement } from '../pricingPlan'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import './removePricingPlanModal.scss'
import { useTranslation } from 'translations'

interface RemovePricingPlanModalProps {
    pricingPlan: PricingPlan
    onRemove: () => void
    onDismiss: () => void
}

export const RemovePricingPlanModal = ({ pricingPlan, onRemove, onDismiss }: RemovePricingPlanModalProps) => {
    const { t } = useTranslation()
    return (
        <Modal
            className="remove-pricing-plan-modal"
            title={t('products.pricing.pricingPlans.removeModal.title')}
            onDismiss={onDismiss}
        >
            <ModalBody>
                <p>{t('products.pricing.pricingPlans.removeModal.body')}</p>
                <PricingPlanElement pricingPlan={pricingPlan} />
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onDismiss} size="large" />
                <PressAndHoldButton text={t('common.remove')} destructive onComplete={onRemove} />
            </ModalFooter>
        </Modal>
    )
}
